import { render, staticRenderFns } from "./ElectionSettingsImportDialog.vue?vue&type=template&id=fcda675e"
import script from "./ElectionSettingsImportDialog.vue?vue&type=script&lang=js"
export * from "./ElectionSettingsImportDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports